import { Routes, Route, Navigate } from "react-router-dom";
import { AuthGate } from "./AuthGate";
import { AdminLayout } from "./components/AdminLayout";
import { RequireSection } from "./components/RequireSection";
import { ToastProvider } from "./components/Toast";
import OverviewPage from "./pages/overview";
import UsersPage from "./pages/users";
import VerificationsPage from "./pages/verifications";
import EntitiesPage from "./pages/entities";
import PaymentsPage from "./pages/payments";
import CouponsPage from "./pages/coupons";
import MarketingPage from "./pages/marketing";
import AbuseReportsPage from "./pages/abuse-reports";
import BackupsPage from "./pages/backups";
import TechnicalPage from "./pages/technical";
import EventsPage from "./pages/events";
import AdminsPage from "./pages/admins";
import AuditPage from "./pages/audit";

export default function App() {
  return (
    <AuthGate>
      <ToastProvider>
        <AdminLayout>
          <Routes>
            <Route path="/" element={<OverviewPage />} />
            <Route
              path="/users"
              element={<RequireSection section="users"><UsersPage /></RequireSection>}
            />
            <Route
              path="/verifications"
              element={<RequireSection section="verifications"><VerificationsPage /></RequireSection>}
            />
            <Route
              path="/entities"
              element={<RequireSection section="entities"><EntitiesPage /></RequireSection>}
            />
            <Route
              path="/payments"
              element={<RequireSection section="payments"><PaymentsPage /></RequireSection>}
            />
            <Route
              path="/coupons"
              element={<RequireSection section="coupons"><CouponsPage /></RequireSection>}
            />
            <Route
              path="/marketing"
              element={<RequireSection section="marketing"><MarketingPage /></RequireSection>}
            />
            <Route
              path="/abuse-reports"
              element={<RequireSection section="abuse_reports"><AbuseReportsPage /></RequireSection>}
            />
            <Route
              path="/backups"
              element={<RequireSection section="backups"><BackupsPage /></RequireSection>}
            />
            <Route
              path="/technical"
              element={<RequireSection section="technical"><TechnicalPage /></RequireSection>}
            />
            <Route
              path="/events"
              element={<RequireSection section="events"><EventsPage /></RequireSection>}
            />
            <Route
              path="/admins"
              element={<RequireSection section="admins"><AdminsPage /></RequireSection>}
            />
            <Route
              path="/audit"
              element={<RequireSection section="audit"><AuditPage /></RequireSection>}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AdminLayout>
      </ToastProvider>
    </AuthGate>
  );
}
